
import axios from 'axios';
export default {
	data(){
		return {
			isLoading: true,
			markup: ''
		}
	},
	props: {
		slug: ''
	},
	watch: {
		slug(){
			this.isLoading = true;
			axios.get('locations/' + this.slug,{
				headers: {
					'X-CSRF-Token': window.csrfToken
				}
			})
			.then( (response) => {
				const node = new DOMParser().parseFromString(response.data, "text/html");
				this.markup = node.querySelector('.BranchDetails-info').innerHTML;
				this.isLoading = false;
			})
		}
	}
};
